<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Análise de Ofício</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Análise ofício',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn
                            :disabled="!$check(user, ['officialanalysis.create'])"
                            type="button" color="primary" elevation="0"
                            @click="modalCreateMultipleAnalysis = true">Criar lote de analises
                        </v-btn>

                        <v-btn
                            :disabled="!$check(user, ['officialanalysis.create'])"
                            id="btnNew" type="button" color="primary" elevation="0"
                            to="/analise-oficio/novo">Incluir</v-btn>
                    </div>
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="email" label="Email" v-model="dataList.filter.email"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>

                                <v-col cols="12" sm="4">
                                    <v-autocomplete dense :items="dataset.clients" label="Caso"
                                        v-model="dataList.filter.client" item-value="id" item-text="name" outlined
                                        hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-select dense :items="getFilterCreditorTypes()" label="Classe"
                                        v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-select dense :items="getAnalysisPhaseTypes()" label="Fase"
                                        v-model="dataList.filter.phase" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Análises</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma análise foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip label text-color="primary">
                                    {{
                                        item.type ? getTypeName(item.type) : 'N/A'
                                    }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.version`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption" 
                                    label :color="getPhaseChipColor(item.version)" text-color="white">
                                    {{ item.version ? getAnalysisPhaseName(item.version) : 'N/A' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.client`]="{ item }">
                                {{ item.userCreditor.client_id
                                    ? getClientName(item.userCreditor.client_id)
                                    : 'N/A' }}
                            </template>

                            <template v-slot:[`item.registration`]="{ item }">
                                {{ item.userCreditor && item.userCreditor.registration
                                    ? formatCpfCnpj(item.userCreditor.registration)
                                    : (item.registration
                                        ? formatCpfCnpj(item.registration)
                                        : 'N/A')
                                }}
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getChipColor(item)" label text-color="white">
                                    {{ getChipLabel(item) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.name`]="{ item }">
                                {{
                                    item.userCreditor && item.userCreditor.name
                                        ? item.userCreditor.name
                                        : (item.name
                                            ? item.name
                                            : 'N/A')
                                }}
                            </template>


                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon
                                        :disabled="(!$check(user, ['officialanalysis.find']))"
                                        @click="viewItem(item)" size="large" class="me-2">
                                        mdi-pencil-outline
                                    </v-icon>

                                    <v-icon
                                        :disabled="(!$check(user, ['officialanalysis.delete']))"
                                        @click="deleteItem(item)" size="large" class="me-2">
                                        mdi-delete
                                    </v-icon>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <!-- Modal incluir multiplas analises-->
        <v-dialog v-model="modalCreateMultipleAnalysis" max-width="600px">

            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Adicionar Analises
                </v-card-title>
                <br>
                <v-card-text>

                    <p>
                        Preencha os campos abaixo para adicionar análises baseadas nestes filtros.
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-icon small color="primary" class="ml-2" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Caso o campo Quantidade não seja preenchido, todas as análises<br>
                                que atendam aos filtros aplicados serão criadas automaticamente.</span>
                        </v-tooltip>
                    </p>
                    <br>
                    <v-form ref="multipleAnalysisForm" @submit.prevent="saveMultipleAnalysis">
                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="qtRequest" type="number" label="Quantidade"
                                    v-model="dataset.multipleAnalysis.req_quantity" outlined hide-details="auto"
                                    :rules="[value => !value || /^\d+$/.test(value) || 'Somente números positivos são permitidos']"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.multipleAnalysis.creditor_type"
                                    :items="dataset.creditorTypes" item-text="name" item-value="id" label="Classe"
                                    outlined hide-details="auto" no-data-text="Nenhuma classe encontrada"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountPlus" type="number" label="Valor igual ou maior"
                                    v-model="dataset.multipleAnalysis.amount_plus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountMinus" type="number" label="valor igual ou menor"
                                    v-model="dataset.multipleAnalysis.amount_minus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                        </v-row>

                        <!-- <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.multipleAnalysis.creditor_origin"
                                    :items="dataset.creditorOrigin" item-text="name" item-value="name" label="Origem do negócio"
                                    outlined hide-details="auto"
                                    no-data-text="Nenhum negócio encontrado" dense></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.multipleAnalysis.has_process"
                                    :items="dataset.hasProcess" item-text="name" item-value="id" label="Processo"
                                    outlined hide-details="auto" no-data-text="Nenhum valor encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row> -->

                        <!-- <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.multipleAnalysis.responsible_id"
                                    :items="dataset.admins" item-text="name" item-value="id"
                                    label="Selecionar responsável" outlined hide-details="auto" required
                                    :rules="[$rules.required]" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row> -->

                        <!-- <v-row>
                            <v-col cols="12" sm="12">
                                <v-checkbox v-model="dataset.multipleAnalysis.without_responsible" dense>
                                    <template #label>
                                        <span class="d-inline-flex align-center">
                                            Somente sem responsável
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                                                        mdi-help-circle
                                                    </v-icon>
                                                </template>
                                                <span>
                                                    Ao marcar esta opção, o responsável selecionado será atribuído às
                                                    habilitações/divergências <br />
                                                    que se enquadrem nas regras selecionadas, e que ainda não possuem um
                                                    responsável designado.
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row> -->

                        <br>
                        <br>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn text color="grey" @click="closeModalCreateMultipleAnalysis">Cancelar</v-btn>
                                <v-btn color="primary" type="submit"
                                    :disabled="(!$check(user, ['officialanalysis.create']))"
                                    :loading="loadingMultipleAnalysis">Salvar</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash';
import _ from 'lodash';
import axios from 'axios';
import creditorTypes from "@/common/data/creditor-types.data";
import object from "@/common/util/object";
import eventStatus from "@/common/data/event-status.data";
import { cpf, cnpj } from 'cpf-cnpj-validator';

Vue.use(VueLodash)

export default {
    name: "EmployeeList",

    data: () => ({
        user: null,
        modalCreateMultipleAnalysis: false,
        loadingMultipleAnalysis: false,
        dataset: {
            data: {},
            clients: [],
            creditorTypes: creditorTypes,
            eventStatus: eventStatus,
            analysisPhaseTypes: [{ id: 1, name: "Fase 1" }, { id: 2, name: "Fase 2" }],
            multipleAnalysis: {
                responsible_id: null,
                req_quantity: null,
                amount_plus: null,
                amount_minus: null,
                without_responsible: false,
                creditor_type: null,
                creditor_origin: null,
            },
        },
        dataList: {
            filter: {
                name: "",
                email: "",
                client: "",
                type: "",
                registration: "",
                phase: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Caso", value: "client" },
                { text: "Classe", value: "type" },
                { text: "Status", value: "status" },
                { text: "Fase", value: "version" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
        this.loadClients();
    },

    methods: {
        getAnalysisPhaseName(phaseId) {
            if (phaseId === null || phaseId === undefined || !this.dataset.analysisPhaseTypes) return 'N/A';
            const phase = this.dataset.analysisPhaseTypes.find(p => p.id === phaseId);
            return phase ? phase.name : 'N/A';
        },

        getPhaseChipColor(phaseId) {
            if (phaseId === 1) return '#7E55AB'; // Fase 1 - roxo
            if (phaseId === 2) return '#29B6F6'; // Fase 2 - azul
            return 'grey'; // default
        },
        
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return 'indigo darken-1';
                default:
                    return 'grey';
            }
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        getChipColor(item) {
            // if (item.currentReview && item.currentReview.status == 0) {
            //     return "#9FA8DA";
            // }

            if (item.status == 4) {
                return "#7E55AB";
            }

            if (item.status == 5) {
                return "#29B6F6";
            }

            return this.getColorByStatus(item.status);
        },

        getChipLabel(item) {
            // if (item.currentReview && item.currentReview.status == 0) {
            //     return "Em análise";
            // }

            return this.enum(item.status, this.dataset.eventStatus, "id", "name");
        },

        enum(status, eventStatus, idKey, nameKey) {
            const matchedStatus = eventStatus.find((e) => e[idKey] === status);
            return matchedStatus ? matchedStatus[nameKey] : 'Desconhecido';
        },


        getTypeName(typeId) {

            switch (typeId) {
                case 1:
                    return "Classe I - Trabalhista";
                case 2:
                    return "Classe II - Garantia Real";
                case 3:
                    return "Classe III - Quirografários";
                case 4:
                    return "Classe IV - ME/EPP";
                case 5:
                    return "Extraconcursais";
                default:
                    return "N/A";
            }
        },

        getClientName(client_id) {

            if (!client_id) {
                return 'N/A';
            }

            const client = this.dataset.clients.find(s => s.id === client_id);

            console.log('client ', client)

            if (client && client.name) {
                return client.name.length > 30 ? client.name.slice(0, 30) + '...' : client.name;
            } else {
                return 'N/A';
            }
        },

        getFilterCreditorTypes() {
            return [{ "id": "", "name": "Todos" }, ...this.dataset.creditorTypes]
        },

        getAnalysisPhaseTypes() {
            return [{ "id": "", "name": "Todos" }, ...this.dataset.analysisPhaseTypes]
        },

        closeModalCreateMultipleAnalysis() {
            this.dataset.multipleAnalysis.req_quantity = null;
            this.dataset.multipleAnalysis.creditor_type = null;
            this.dataset.multipleAnalysis.creditor_origin = null;
            this.dataset.multipleAnalysis.amount_minus = null;
            this.dataset.multipleAnalysis.amount_plus = null;
            this.dataset.multipleAnalysis.has_process = null;
            this.dataset.multipleAnalysis.responsible_id = null;
            this.dataset.multipleAnalysis.without_responsible = false;

            this.modalCreateMultipleAnalysis = false;
        },

        async load() {

            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            if (search.registration) {
                search.registration = search.registration.replace(/\D/g, '');
            }

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/admin/officio-analysis', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = [{ id: "", name: "Todos " }, ...data];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        viewItem(item) {
            this.$router.push(`analise-oficio/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/officio-analysis/${item.id}`)

                this.$dialog.notify.info("Análise excluída com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

        async saveMultipleAnalysis() {

            if (
                !this.dataset.multipleAnalysis.creditor_type
                || !this.dataset.multipleAnalysis.amount_plus
            ) {
                this.$dialog.notify.error(
                    "Campos 'Classe' e 'Valor igual ou maior' são obrigatórios!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Confirmar adicionar Análises',
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.loadingMultipleAnalysis = true;

            let payload = this.buildPayloadRedirect();

            try {

                const response = await axios.post(`/api/admin/officio-analysis/bulk-create`, payload);

                if (response.data && response.data.status) {
                    const message = response.data.content || "Análise(s) criada(s) com sucesso!";

                    this.$dialog.notify.info(message, {
                        position: "top-right",
                        timeout: 5000
                    });
                } else {
                    this.$dialog.notify.error("Erro desconhecido ao criar análises!", {
                        position: "top-right",
                        timeout: 5000
                    });
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.loadingMultipleAnalysis = false;
                this.closeModalCreateMultipleAnalysis();
                this.load();
            }
        },

        buildPayloadRedirect() {
            const data = {
                req_quantity: this.dataset.multipleAnalysis.req_quantity,
                creditor_type: this.dataset.multipleAnalysis.creditor_type,
                amount_plus: this.dataset.multipleAnalysis.amount_plus,
                amount_minus: this.dataset.multipleAnalysis.amount_minus,

            }

            return data;
        },
    },
};
</script>